import { render, staticRenderFns } from "./StrokeLeftRightIcon.vue?vue&type=template&id=135c4b8f&"
import script from "./StrokeLeftRightIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeLeftRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports